import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FIREBASE_DB } from "../../firebase.js";
import { collection, addDoc } from "firebase/firestore";
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [loading, setLoading] = useState(false);

  const captchaRef = useRef(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      toast.error(t("contact.form.error"));
      return;
    }

    setLoading(true);

    try {
      await addDoc(collection(FIREBASE_DB, "messages"), {
        ...formData,
        timestamp: new Date(),
      });

      toast.success(t("contact.form.success"));
      setFormData({ name: "", email: "", subject: "", message: "" });
      captchaRef.current?.reset();
      setCaptchaValue(null);
    } catch (err) {
      console.error("Error adding document: ", err);
      toast.error(t("contact.form.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container section-title" data-aos="fade-up">
        <h2>{t("contact.title")}</h2>
        <p>{t("contact.subtitle")}</p>
      </div>

      <div className="container" data-aos="fade" data-aos-delay="100">
        <div className="row gy-4">
          <div className="col-lg-4"></div>

          <div className="col-lg-8">
            <form
              onSubmit={handleSubmit}
              className="php-email-form"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="row gy-4">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder={t("contact.form.name")}
                    required
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder={t("contact.form.email")}
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-12">
                  <input
                    type="text"
                    name="subject"
                    className="form-control"
                    placeholder={t("contact.form.subject")}
                    required
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-12">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="6"
                    placeholder={t("contact.form.message")}
                    required
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="col-md-12 text-center">
                  <ReCAPTCHA
                    sitekey="6LfnnycrAAAAANLhLXlYbZQBzNj47IS-3Pz4WzRH"
                    onChange={handleCaptchaChange}
                    ref={captchaRef}
                    className="mb-3"
                  />

                  {loading && (
                    <div className="loading">{t("contact.form.loading")}</div>
                  )}

                  <button type="submit">{t("contact.form.submit")}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Toast-ul apare aici */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </section>
  );
};

export default Contact;
